import {
  type CurrentUserDto,
  getCurrentUser as sdkGetCurrentUser,
  updateCurrentUser as sdkUpdateCurrentUser,
} from "~/lib/api";

/**
 * Network + mapping layer for the user-profile screen (HAN-66): read the current
 * profile and update the phone number. Mirrors the discriminated-union shape of
 * the other `~/lib/*` wrappers so screens stay in switch-form.
 */

export type ProfileResult = { status: "ok"; data: CurrentUserDto } | { status: "error" };

/** Read the authenticated user (`GET /auth/me`), including their phone number. */
export async function fetchProfile(): Promise<ProfileResult> {
  try {
    const result = await sdkGetCurrentUser();
    if (result.data && !result.error) {
      return { status: "ok", data: result.data };
    }
    return { status: "error" };
  } catch {
    return { status: "error" };
  }
}

export type UpdatePhoneResult =
  | { status: "ok"; data: CurrentUserDto }
  | { status: "invalid" }
  | { status: "error" };

/**
 * Set or clear the caller's phone number (`PATCH /auth/me`). Pass `null` to
 * remove it. A 400 is surfaced as `invalid` so the form can show a field error
 * even though the client also validates the format up front.
 */
export async function updateProfilePhone(phoneE164: string | null): Promise<UpdatePhoneResult> {
  try {
    const result = await sdkUpdateCurrentUser({ body: { phoneE164 } });
    if (result.data && !result.error) {
      return { status: "ok", data: result.data };
    }
    if (result.response.status === 400) return { status: "invalid" };
    return { status: "error" };
  } catch {
    return { status: "error" };
  }
}
